import e from "./keys.js";
function r(r) {
  var t = function t(e) {
      return r[e];
    },
    n = "(?:" + e(r).join("|") + ")",
    u = RegExp(n),
    o = RegExp(n, "g");
  return function (e) {
    return e = null == e ? "" : "" + e, u.test(e) ? e.replace(o, t) : e;
  };
}
export { r as default };